var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('vue-headful',{attrs:{"title":"💌 – Yay verified!"}}),_c('h3',[_vm._v("YAY You just verified yourself")]),_c('router-link',{attrs:{"to":'/to/'+ _vm.url}},[_vm._v(_vm._s(_vm.url))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }